import React from "react";
import { X } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { useLang } from "@/i18n";

const Row = ({ label, value, testid }) => (
  <div className="flex items-start justify-between gap-4 border-b border-border/60 py-1.5 last:border-0">
    <span className="text-[11px] font-semibold uppercase tracking-wider text-muted-foreground">{label}</span>
    <span className="text-right text-sm font-medium break-all" data-testid={testid}>{value || "—"}</span>
  </div>
);

export default function UserInfoDialog({ user, onClose }) {
  const { t } = useLang();
  if (!user) return null;
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-sm bg-background" data-testid="user-info-dialog">
        <DialogHeader>
          <DialogTitle className="font-display flex items-center gap-2">
            {user.nickname || user.first_name} {user.last_name}
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-0">
          <Row label={t("u_barcode")} value={user.number} testid="info-number" />
          <Row label={t("u_staff_number")} value={user.staff_number} testid="info-staff" />
          <Row label={t("u_nickname")} value={user.nickname} testid="info-nickname" />
          <Row label={t("email")} value={user.email} testid="info-email" />
          <Row label={t("phone")} value={user.phone} testid="info-phone" />
          <Row label={t("u_role")} value={t(`role_${user.role}`)} testid="info-role" />
          <Row label={t("language")} value={(user.language || "").toUpperCase()} testid="info-language" />
          <Row label={t("status")} value={user.active
            ? `${t("active")}${user.must_change_password ? ` · ${t("pw_pending")}` : ""}`
            : t("inactive")} testid="info-status" />
        </div>
        <button type="button" onClick={onClose} data-testid="user-info-close"
          className="mt-2 inline-flex items-center justify-center gap-1.5 rounded-lg border border-border px-3 py-2 text-sm font-semibold hover:bg-secondary transition-colors">
          <X className="h-4 w-4" />{t("close")}
        </button>
      </DialogContent>
    </Dialog>
  );
}
